import { useForm,SubmitHandler } from 'react-hook-form';
import { Row, Col, Label, FormGroup, Form, Input } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import { useDispatch } from 'react-redux';
import { Cancel, Email, Mobile, Name, Phone, Save } from '../../../Constant';
import { UpdateUserPropsType, UserUpdateType } from '../../../Type/ContactType';
import { dynamicImage } from '../../../Service/DynamicImage';
import { setEditData } from '../../../Redux-Toolkit/Reducers/ContactSlice';
import { toast } from 'react-toastify';

const UpdateUser = ({ editdata, userEditCallback }:UpdateUserPropsType) => {
  const { register, handleSubmit, formState: { errors } } = useForm<UserUpdateType>();
  const dispatch =useDispatch()

  const UpdateContact:SubmitHandler<UserUpdateType> = (updatedData) => {
    const withImageData ={...updatedData,avatar:dynamicImage("user/user.png")}
    userEditCallback(false,withImageData)
    dispatch(setEditData(withImageData));
    toast.success("User Update Success")
  };
  
  return (
      <div className="contact-editform ps-0 m-auto">
        <Form onSubmit={handleSubmit(UpdateContact)}>
          <Row className='g-2'>
            <Col
             md="12" className="mb-3">
              <Label check>{Name}</Label>
              <Row>
                <Col sm="6">
                  <input className="form-control" type="text"  defaultValue={editdata?.name} {...register('name', { required: true })} />
                  {errors.name &&  <span className='text-danger'>First name is required</span>}
                </Col>
                <Col sm="6">
                  <input className="form-control" type="text"  defaultValue={editdata.surename} {...register('surename', { required: true })} />
                  {errors.surename && <span className='text-danger'>Last name is required</span>}
                </Col>
              </Row>
            </Col>
            <Col md="12" className="mb-3">
              <Label check>{Email}</Label>
              <input className="form-control" type="text"  defaultValue={editdata.email} {...register('email', { required: true })} />
             {errors.email && <span className='text-danger'>Please enter email between 18 to 70 year.</span>}
            </Col>
            <FormGroup className="mb-3 col-md-12 my-0">
              <Row>
                <Col sm="6">
                  <Label htmlFor="con-phone" check>{Phone}</Label>
                  <input className="form-control"  type="number" defaultValue={editdata.mobile} {...register('mobile', { required: true })} />
                  {errors.mobile && <span className='text-danger'>Please enter Mobile no.</span>}
                </Col>
                <Col sm="6">
                  <Label htmlFor="con-phone" check>{Mobile}</Label>
                  <Input type="select" className="form-control" >
                    <option value="1">Mobile</option>
                    <option value="2">Work</option>
                    <option value="3">Other</option>
                  </Input>
                </Col>
              </Row>
            </FormGroup>
          </Row>
          <Btn color='secondary'  className='update-contact me-1'  >{Save}</Btn>
          <Btn color='primary' onClick={()  => userEditCallback(false,editdata)}>{Cancel}</Btn>
        </Form>
      </div>
  );
};

export default UpdateUser;